import React, { useState } from "react";
import { updateAssetReferral } from "services/assetRecoveryService";
import { useTooltip } from "context/TooltipProvider";
import { Referral } from "types";
import ReadMoreText from "components/ReadMoreText";
import { useTranslation } from "react-i18next";

interface SuspensionContainerProps {
  referralId: string;
  action_status?: string;
  isAssetCoordinator: boolean;
  onSuspensionCreated?: (res: any) => void;
  setActiveTab?: (tab: string) => void;
  referral?: Referral | null;
}

export default function SuspensionContainer({
  referralId,
  action_status,
  isAssetCoordinator,
  onSuspensionCreated,
  setActiveTab,
  referral,
}: SuspensionContainerProps) {
  const [isApproving, setIsApproving] = useState(false);
  const [isForwarding, setIsForwarding] = useState(false);
  const { showTooltip } = useTooltip();
  const { t } = useTranslation();

  const handleApproveSuspension = async () => {
    try {
      setIsApproving(true);

      const formData = new FormData();
      formData.append("previous_status", referral?.action_status as string);
      formData.append("action_status", "Suspended");
      const response = await updateAssetReferral(referralId, formData);
      if (onSuspensionCreated && response) {
        onSuspensionCreated(response);
        setActiveTab?.("Referral");
      }
      showTooltip(t("suspension_request_approved_successfully"), "success");
    } catch (error) {
      console.error("Error approving suspension:", error);
      showTooltip(t("failed_to_approve_suspension_request"), "error");
    } finally {
      setIsApproving(false);
    }
  };

  const handleRejectSuspension = async () => {
    try {
      setIsForwarding(true);

      const formData = new FormData();
      formData.append("action_status", "Suspension Rejected");

      const response = await updateAssetReferral(referralId, formData);
      if (onSuspensionCreated && response) {
        onSuspensionCreated(response);
        setActiveTab?.("Referral");
      }
      showTooltip(t("suspension_request_rejected_successfully"), "success");
    } catch (error) {
      console.error("Error rejecting suspension:", error);
      showTooltip(t("failed_to_reject_suspension_request"), "error");
    } finally {
      setIsForwarding(false);
    }
  };

  console.log({
    action_status,
    st: action_status === "Suspension Requested",
    isAssetCoordinator,
  });

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <p
        className="font-medium"
        style={{ color: "var(--Prime-Blue, #0A1D39)" }}
      >
        Suspension Requested
      </p>
      <div className="flex flex-col">
        <span style={{ color: "#432101AB", fontSize: "15px" }}>Summary</span>
        <div style={{ color: "var(--Prime-Blue, #0A1D39)" }}>
          {referral?.suspension_request_summary ? (
            <ReadMoreText
              text={referral?.suspension_request_summary}
              maxLines={3}
              fontSize="14px"
            />
          ) : (
            "—"
          )}
        </div>
      </div>
      {/* Coordinator Actions */}
      {isAssetCoordinator && action_status === "Suspension Requested" && (
        <div className="mt-3 flex gap-3">
          <button
            onClick={handleRejectSuspension}
            disabled={isForwarding}
            className="px-4 py-2 text-sm font-medium bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-60 transition-colors"
          >
            {isForwarding ? "Processing..." : "Reject"}
          </button>

          <button
            onClick={handleApproveSuspension}
            disabled={isApproving}
            className="px-4 py-2 text-sm font-medium bg-black text-white rounded-md hover:bg-gray-700 disabled:opacity-60 transition-colors"
          >
            {isApproving ? "Processing..." : "Approve"}
          </button>
        </div>
      )}
    </div>
  );
}
